import {
  catchFacePartsObjs,
  commonPartsObjs,
  dispatchBestSelectObjects,
  dispatchGoldLineObjects,
  dispatchJuniorLineObjects,
  web2Objs
} from 'src/features/yellStory/constants/colors'
import { StateObj } from 'src/types'
import { checkYellStoryWeb2 } from '../simulatedSpecification'

const backPartsObjectSwitcher = (indexIntegrated: string, middleIntegrated: string, ringIntegrated: string): StateObj[] => {
  const indexFingerParts =
    indexIntegrated === 'atIndexFinger'
      ? [{ label: '人差指3', value: 'indexWeb', order: 11 }]
      : [
          { label: '人差指3', value: 'indexWeb', order: 11 },
          { label: '人差指4', value: 'indexMiddle', order: 12 }
        ]

  const middleFingerParts =
    middleIntegrated === 'atMiddleFinger'
      ? [{ label: '中指4', value: 'middleIndex', order: 13 }]
      : [
          { label: '中指5', value: 'middleIndex', order: 14 },
          { label: '中指6', value: 'middleRing', order: 15 }
        ]
  const ringFingerParts =
    ringIntegrated === 'atRingFinger'
      ? [{ label: '薬指5', value: 'ringMiddle', order: 16 }]
      : [
          { label: '薬指7', value: 'ringMiddle', order: 17 },
          { label: '薬指8', value: 'ringLittle', order: 18 }
        ]
  return [
    ...commonPartsObjs,
    { label: '親指1', value: 'thumbOut', order: 9 },
    { label: '親指2', value: 'thumbWeb', order: 10 },
    ...indexFingerParts,
    ...middleFingerParts,
    ...ringFingerParts,
    { label: '小指9', value: 'littleRing', order: 19 },
    { label: '小指10', value: 'littleOut', order: 20 },
    { label: 'バンド', value: 'listBelt', order: 21 }
  ]
}

export const partsObjectsSwitcher = (
  figurePanelNum: number,
  leatherIntegratedIndexValue: string,
  leatherIntegratedMiddleValue: string,
  leatherIntegratedRingValue: string,
  webPartsValue: string
): StateObj[] => {
  const backFaceParts = backPartsObjectSwitcher(leatherIntegratedIndexValue, leatherIntegratedMiddleValue, leatherIntegratedRingValue)
  const catchFacePanelIndex = 0
  const needWeb2 = checkYellStoryWeb2(webPartsValue)
  const partsObjects = figurePanelNum === catchFacePanelIndex ? catchFacePartsObjs : backFaceParts
  const filteredWeb2Parts = needWeb2 ? [...partsObjects, web2Objs] : partsObjects
  return filteredWeb2Parts.sort((a, b) => a.order - b.order)
}

export const dispatchObjectsGenerator = (series: 'newBestSelect' | 'newGoldLineNext' | 'newJuniorLine' | 'unselected') => {
  const partsColorCaution = series === 'unselected' && 'パーツ設定にて "シリーズ" を選択してください'
  switch (series) {
    case 'newBestSelect':
      return { dispatchObjects: dispatchBestSelectObjects }
    case 'newGoldLineNext':
      return { dispatchObjects: dispatchGoldLineObjects }
    case 'newJuniorLine':
      return { dispatchObjects: dispatchJuniorLineObjects }
    default:
      return { dispatchObjects: {}, partsColorCaution }
  }
}
